import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AccountService } from '../services/account.service';
import { Observable, of } from 'rxjs';
import { PasswordResetWindow } from '../types/PasswordResetWindow';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class PasswordResetWindowResolve {
  public constructor(private accountService: AccountService) {}

  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  public resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const passwordResetWindow: PasswordResetWindow = {
      hash: route.params.resetWindowHash,
      id: route.params.resetWindowId
    };
    return this.accountService.validatePasswordWindow(passwordResetWindow, route.params.clientCode).pipe(
      map(((success) => success)),
      catchError((error) => {
        return of({ error });
      }));
  }
}
